import { redirectTo } from "./redirect";
import getScopedPath from "owa-url/lib/getScopedPath";
import { isBootFeatureEnabled } from "owa-metatags";

export function redirectToOwa(appName: string): boolean {
    if (isBootFeatureEnabled("auth-langtz-preservePath")) {
        const redirectUrl = new URL(self.location.href);
        const retryKey = "langtzRedirect";
        if (redirectUrl.searchParams.get(retryKey) === "true") {
            return false;
        }
        
        redirectUrl.searchParams.set(retryKey, "true");
        return redirectTo(redirectUrl.href);
    }
    
    let redirectPath = getScopedPath("/owa") + "/";
    if (appName == "Calendar" || appName == "MiniCalendar") {
        redirectPath = redirectPath + "?path=/calendar";
    }
    else if (appName == "People" || appName == "MiniPeople") {
        redirectPath = redirectPath + "?path=/people";
    }
    return redirectTo(redirectPath);
}
